module.exports = __webpack_public_path__ + "img/need-ui-ux-expertise.5ba929a.png";